import texts from '../../book.texts'

class PaginatorController {
    constructor(config, PaginatorFactory, $scope, $stateParams, $rootScope, Share) {
        this.name = 'paginator'

        this.config = config
        this.$scope = $scope
        this.$stateParams = $stateParams
        this.$rootScope = $rootScope
        this.PaginatorFactory = PaginatorFactory
        this.ShareFactory = Share
    }

    paginationInitializer(activePage, pagesCount) {
        this.activePage = activePage
        this.pages = []
        this.maxPages = pagesCount
        this.pagesCount = 15

        // Save maxPages in factory
        this.PaginatorFactory.setPagesCount(this.maxPages)

        // Save activePageNumber in factory
        this.PaginatorFactory.setActivePageNumber(this.activePage)

        const pagesInitialCount = this.maxPages < this.pagesCount ? this.maxPages : this.pagesCount

        for (let i = 1; i <= pagesInitialCount; i++) {
            this.pages.push(i)
        }
    }

    $onInit() {
        this.render()

        this.watchForDataReady()
        this.activePageChangeListener()
    }

    render() {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            SHARE
        } = texts[this.language]

        this.share = SHARE
    }

    watchForDataReady() {
        this.$scope.$watch(
            () => this.PaginatorFactory.getDataReady(),
            (newValue) => {
                if (newValue === true) {
                    this.paginationInitializer(this.PaginatorFactory.getActivePageNumber(), this.PaginatorFactory.getPagesCount())
                }
            }
        )
    }

    activePageChangeListener() {
        this.$rootScope.$on('activePageChangeEvent', (ev, mustApplyScope) => {
            const newValue = this.PaginatorFactory.getActivePageNumber()

            this.onChangePage(newValue)

            if (mustApplyScope) {
                this.$scope.$apply()
            }
        })
    }

    onChangePage(pageNumber) {
        if (pageNumber > 0) {
            $('.flipbook').turn('page', pageNumber * 2)

            this.activePage = pageNumber

            // Save new activePage in factory
            this.PaginatorFactory.setActivePageNumber(this.activePage)
        }

        const lastPage = this.pages[this.pages.length - 1]
        const firstPage = this.pages[0]

        if (pageNumber === 1) {
            this.paginationInitializer(pageNumber, this.PaginatorFactory.getPagesCount())
        }

        // Next 15 pages
        if (pageNumber >= lastPage && pageNumber < this.maxPages) {
            const newList = []

            let newListLastElement = pageNumber + 13
            newListLastElement = newListLastElement > this.maxPages ? this.maxPages : newListLastElement

            for (let i = pageNumber - 1; i <= newListLastElement; i++) {
                newList.push(i)
            }
            this.pages = newList
        } else if (pageNumber <= firstPage && pageNumber > 1) {
            const newList = []

            let newListFirstElement = pageNumber - 13
            newListFirstElement = newListFirstElement < 1 ? 1 : newListFirstElement

            for (let i = newListFirstElement; i <= pageNumber + 1; i++) {
                newList.push(i)
            }

            this.pages = newList
        }
    }

    shareGuidebook() {
        const url = `${this.config.frontUrl}/shared-moments/book/step-3?bookId=${this.$stateParams.bookId}`

        this.ShareFactory
            .shareObject(url)
    }
}

PaginatorController.$inject = ['config', 'PaginatorFactory', '$scope', '$stateParams', '$rootScope', 'Share']

export default PaginatorController



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/paginator/paginator.controller.js